// extracted by mini-css-extract-plugin
export var hideEditor = "_km-2";
export var infoIcon = "_km-3";
export var label = "_km-1";
export var labelContainer = "_km-0";
export var readonlyText = "_km-4";